(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const slides = [...root.querySelectorAll('[data-slide]')];
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    let current = 0;
    function show(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== current; });
      thumbs.forEach((thumb, i) => { thumb.setAttribute('aria-pressed', String(i === current)); });
      root.querySelector('[data-gallery-counter]').textContent = `${current + 1} / ${slides.length}`;
    }
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(current - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(current + 1));
    root.querySelector('.bo-slides')?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1); }
    });
    const form = root.querySelector('form.bo-form');
    const quantity = root.querySelector('[data-cart-quantity]');
    const variantInput = form?.querySelector('[data-bo-variant]');
    const baseVariant = variantInput?.value;
    const subscription = form?.querySelector('[data-bo-subscribe]');
    const planInput = form?.querySelector('[data-bo-plan-input]');
    const terms = form?.querySelector('[data-bo-purchase-terms]');
    const money = new Intl.NumberFormat('it-IT', {
      style: 'currency', currency: JSON.parse(form?.querySelector('[data-bo-currency]')?.textContent || '"EUR"')
    });
    function selection() {
      const selected = form?.querySelector('input[name="bo-kit"]:checked');
      const recurring = Boolean(subscription?.checked);
      return {
        selected, recurring,
        variant: recurring ? selected?.dataset.subscriptionVariant : baseVariant,
        quantity: recurring ? 1 : Number(selected?.value || 1),
        price: Number(recurring ? selected?.dataset.subscriptionPrice : selected?.dataset.oncePrice)
      };
    }
    function syncPurchase() {
      const choice = selection();
      if (!choice.selected) return;
      quantity.value = String(choice.quantity);
      variantInput.value = choice.variant;
      form.querySelectorAll('input[name="selling_plan"]').forEach(input => {
        input.disabled = !choice.recurring;
        input.value = choice.recurring ? subscription.dataset.planId : '';
      });
      form.querySelectorAll('input[name="bo-kit"]').forEach(radio => {
        const card = radio.closest('.bo-bundle');
        card.classList.toggle('is-selected', radio.checked);
        const price = Number(choice.recurring ? radio.dataset.subscriptionPrice : radio.dataset.oncePrice);
        card.querySelector('[data-kit-price]').textContent = money.format(price / 100);
        const unitPrice = card.querySelector('[data-unit-price]');
        if (unitPrice) unitPrice.textContent = money.format(price / 100) + ' / conf.';
      });
      if (terms) terms.textContent = choice.recurring
        ? `Abbonamento: ${money.format(choice.price / 100)} per ${choice.selected.value} ${choice.selected.value === '1' ? 'confezione' : 'confezioni'}, ogni mese. Lo stesso kit viene spedito e addebitato a ogni rinnovo. Puoi annullare prima del rinnovo dal portale clienti.`
        : 'Acquisto singolo: nessun rinnovo automatico.';
      const button = form.querySelector('button[type="submit"]');
      button.disabled = button.dataset.boAvailable !== 'true' || (choice.recurring && choice.selected.dataset.subscriptionAvailable !== 'true');
    }
    form?.querySelectorAll('input[name="bo-kit"]').forEach(radio => radio.addEventListener('change', syncPurchase));
    subscription?.addEventListener('change', syncPurchase);
    syncPurchase();
    // The app can inject a hidden plan field asynchronously. Keep its native fallback in sync with the visible opt-in.
    if (form && subscription) new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('input[name="selling_plan"]') || node.querySelector?.('input[name="selling_plan"]'))))) syncPurchase();
    }).observe(form, {childList:true, subtree:true});
    form?.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (button.disabled) return;
      const choice = selection();
      if (!choice.variant || !choice.quantity || (choice.recurring && (!subscription.dataset.planId || !choice.price))) return;
      const status = form.querySelector('[data-cart-status]');
      const label = button.querySelector('span');
      const originalText = label.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      label.textContent = 'AGGIUNTA IN CORSO…';
      status.hidden = true;
      try {
        const item = {id:Number(choice.variant), quantity:choice.quantity};
        if (choice.recurring) item.selling_plan = Number(subscription.dataset.planId);
        await window.BenfioraCart.add([item], form);
      } catch (error) {
        status.textContent = error.message;
        status.hidden = false;
      } finally {
        button.removeAttribute('aria-busy');
        label.textContent = originalText;
        syncPurchase();
      }
    });
    root.querySelectorAll('[data-open-review]').forEach(link => link.addEventListener('click', event => {
      const panel = root.querySelector('#origano-scrivi-recensione');
      if (!panel) return;
      event.preventDefault();
      panel.open = true;
      panel.scrollIntoView({behavior:'smooth',block:'start'});
      panel.querySelector('input[type="text"]')?.focus({preventScroll:true});
    }));
    if (location.hash === '#origano-scrivi-recensione') {
      const panel = root.querySelector('#origano-scrivi-recensione');
      if (panel) panel.open = true;
    }
    const reviewTrack = root.querySelector('[data-review-track]');
    function moveReviews(direction) {
      if (!reviewTrack) return;
      const maxScroll = reviewTrack.scrollWidth - reviewTrack.clientWidth;
      if (maxScroll < 3) {
        if (direction > 0) reviewTrack.append(reviewTrack.firstElementChild);
        else reviewTrack.prepend(reviewTrack.lastElementChild);
        return;
      }
      if (direction > 0 && reviewTrack.scrollLeft >= maxScroll - 3) {
        reviewTrack.scrollTo({left:0,behavior:'smooth'});
      } else if (direction < 0 && reviewTrack.scrollLeft <= 3) {
        reviewTrack.scrollTo({left:maxScroll,behavior:'smooth'});
      } else {
        reviewTrack.scrollBy({left:direction * reviewTrack.clientWidth * .9,behavior:'smooth'});
      }
    }
    root.querySelector('[data-reviews-prev]')?.addEventListener('click', () => moveReviews(-1));
    root.querySelector('[data-reviews-next]')?.addEventListener('click', () => moveReviews(1));
    const offer = root.querySelector('[data-deadline]');
    if (offer) {
      const end = Date.parse(offer.dataset.deadline);
      const formatter = new Intl.DateTimeFormat('it-IT', {dateStyle:'long',timeStyle:'short',timeZone:'Europe/Rome'});
      function tick() {
        const remaining = end - Date.now();
        if (!Number.isFinite(end) || remaining <= 0) { offer.hidden = true; return false; }
        offer.hidden = false;
        offer.querySelector('[data-end-date]').textContent = formatter.format(end);
        offer.querySelector('[data-end-date]').dateTime = new Date(end).toISOString();
        const sec = Math.floor(remaining / 1000);
        const days = Math.floor(sec / 86400);
        offer.querySelector('[data-countdown]').textContent = `${days ? days + ' g ' : ''}${String(Math.floor(sec / 3600) % 24).padStart(2,'0')}:${String(Math.floor(sec / 60) % 60).padStart(2,'0')}:${String(sec % 60).padStart(2,'0')}`;
        return true;
      }
      if (tick()) { const timer = setInterval(() => { if (!tick() || !offer.isConnected) clearInterval(timer); }, 1000); }
    }
  }
  document.querySelectorAll('[data-origano]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-origano]').forEach(init));
})();
